import { Component, OnInit } from '@angular/core';
import { CallBackEndService } from '../call-back-end.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
// import * as $ from 'jquery';
// import 'datatables.net';

import * as $ from 'jquery'; 
import 'datatables.net';

@Component({
  selector: 'app-positivepaystatus',
  templateUrl: './positivepaystatus.component.html',
  styleUrls: ['./positivepaystatus.component.css']
})
export class PositivepaystatusComponent implements OnInit {
  scoAccounts: any;
  isShow: string='show';
  userName: string;
  currentDateFormatted: string;
  custNo: string;
  mytime:Date = new Date();
  currentYear:any= this.mytime.getUTCFullYear();
  currentDate:any= this.mytime.getUTCDate();
  currentMonth:any= this.mytime.getUTCMonth() + 1;
  acctNo: string;
  acctNoError: string;
  chequeNo: string;
  chequeNoError: string;
  errorFromBackend: string;
  errorMsg: string;
  positivepayData: any;
  data: any;
  dtOptions: DataTables.Settings = {};
  ppsList: any;
  constructor( private webService: CallBackEndService,private spinnerService: Ng4LoadingSpinnerService) {
    // $('#transactionTable').DataTable();
    // this.showOtpInput='no';
    // this.readonlyflag=false;
    this.scoAccounts=JSON.parse(sessionStorage.getItem('scoAccounts'));
    this.userName=sessionStorage.getItem('storedUserName');
    this.custNo=sessionStorage.getItem('custNo'); 
    this.currentDateFormatted=this.currentDate+'-'+this.currentMonth+'-'+this.currentYear;
    console.log('date is: '+this.currentDateFormatted);

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 5,
      processing: true
    };
   }


  ngOnInit() {
  }

  validateAcctNo(){
    console.log('selecteed acc is: '+this.acctNo);
    if(this.acctNo==='' || this.acctNo==undefined || this.acctNo==null){
      this.acctNoError='yes';
      console.log('selecteed acc is1: '+this.acctNo);
      return false;
    }else{
      this.acctNoError='';
      console.log('selecteed acc is2: '+this.acctNo);
      return true;
    }
  }
  changeValidateAcctNo(){
    this.acctNoError='';
    this.errorFromBackend='';
  }
  
  validateChequeNo(){
    if(this.chequeNo==='' || this.chequeNo==undefined || this.chequeNo==null){
        this.chequeNoError='yes';
        return false;
    }else{
      this.chequeNoError='';
        return true;
    }
  }
  changeValidateChequeNo(){
    this.chequeNoError='';
  }
  
  positivePayStatusSubmit(){
    if(this.validateAcctNo() ){
      const request : IbRequest = new IbRequest();
      request.param1='';  
      request.param2=this.acctNo;
      request.param3=this.chequeNo;

      this.spinnerService.show();
      this.webService.getResponse(request,'positivePayStatusSubmit').subscribe((data:IbResponse)=>{
        this.spinnerService.hide();
         if(data.status!==null && data.status==='S200'){
           console.log('show data');
           this.errorFromBackend='';
          // this.positivepayData=data.param6;
           if(data.param6!=null){
             this.isShow='success';
             this.data=data.param6;
             this.ppsList = data.param6;
             setTimeout(function(){ $('#example').DataTable({ responsive: true});},50); 

           }

         }else{
          this.errorFromBackend='yes';
          this.errorMsg=data.param1;

         }
      });
      
    }
  }

  sortBy(param){
    if(param === 'payeename'){
      this.data =  this.data.sort((a, b) => (a.PayeeName.toLowerCase() > b.PayeeName.toLowerCase() ? 1 : -1));
    }else if(param === 'statDesc' ){
      this.data =  this.data.sort((a, b) => (a.statusDesc > b.statusDesc ? 1 : -1));
    }else if(param === 'amount' ){
      this.data =  this.data.sort((a, b) => (a.Amount > b.Amount ? -1 : 1));
    }else if(param === 'chequeNumb' ){
      this.data =  this.data.sort((a, b) => (a.ChequeNo > b.ChequeNo ? 1 : -1)); //asc
    }else if(param === 'edate' ){
      this.data =  this.data.sort((a, b) => (a.EntryDate > b.EntryDate ? -1 : 1)); //desc
    }
    
  }

} 



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/positivepaystatus/positivepaystatus.component.ts